import { useState } from 'react';
import { StateSnapshot } from 'react-virtuoso';
import { resolveStickyOffset } from '../../v2/utils/catalogSectionScroll.utils';
import useSnapshotController from '../SnapshotController/useSnapshotController';
import { UseCatalogSectionsControllerParams } from './useCatalogSectionsController.interfaces';

const useCatalogSectionsController = ({
  sectionLimits,
  isOfflineMode,
  scrollParent,
  stickyToolbar,
  stickyFilterBar,
  mode,
  virtuoso,
}: UseCatalogSectionsControllerParams) => {
  const [targetIndex, setTargetIndex] = useState<number | null>(null);
  const [isScrollingFast, setIsScrollingFast] = useState(false);

  const snapshotController = useSnapshotController<StateSnapshot>({ isOfflineMode, mode });

  const scrollToSection = (sectionId: string) => {
    const groupIndex = sectionLimits.findIndex((limit) => limit.sectionId === sectionId);

    if (groupIndex < 0 || !scrollParent) {
      return;
    }

    setTargetIndex(sectionLimits[groupIndex].startRowIndex);

    virtuoso.current?.scrollToIndex({
      groupIndex,
      align: 'start',
      behavior: 'smooth',
      offset: -resolveStickyOffset({ scrollParent, stickyToolbar, stickyFilterBar }),
    });
  };

  return {
    isScrollingFast,
    targetIndex,
    scrollToSection,
    startScrollingFast: () => setIsScrollingFast(true),
    endScrollingFast: () => setIsScrollingFast(false),
    updateSnapshot: snapshotController.updateSnapshot,
    updateSnapshotDetails: snapshotController.updateSnapshotDetails,
    getSnapshot: snapshotController.getSnapshot,
    reachTargetIndex: () => setTargetIndex(null),
  };
};

export default useCatalogSectionsController;
